import type { FunctionComponent, SVGProps } from "react"

import { zodiacIcons } from "@/features/advisors"

import Sun from "@/assets/svg/lpr4/planets/Sun.svg?react"
import Moon from "@/assets/svg/lpr4/planets/Moon.svg?react"
import Mercury from "@/assets/svg/lpr4/planets/Mercury.svg?react"
import Venus from "@/assets/svg/lpr4/planets/Venus.svg?react"
import Mars from "@/assets/svg/lpr4/planets/Mars.svg?react"
import Jupiter from "@/assets/svg/lpr4/planets/Jupiter.svg?react"
import Saturn from "@/assets/svg/lpr4/planets/Saturn.svg?react"
import Uranus from "@/assets/svg/lpr4/planets/Uranus.svg?react"
import Neptune from "@/assets/svg/lpr4/planets/Neptune.svg?react"
import Pluto from "@/assets/svg/lpr4/planets/Pluto.svg?react"

import type { Planet, Zodiac } from "../types"

type SvgComponent = FunctionComponent<SVGProps<SVGSVGElement>>

const PLANET_ICON: Record<Planet, SvgComponent> = {
  sun: Sun,
  moon: Moon,
  mercury: Mercury,
  venus: Venus,
  mars: Mars,
  jupiter: Jupiter,
  saturn: Saturn,
  uranus: Uranus,
  neptune: Neptune,
  pluto: Pluto,
}

/**
 * Lowercase report `Zodiac` → shared (advisors) glyph. A precomputed map (not a
 * getter fn) so callers index it directly — `react-hooks/static-components`
 * forbids calling a fn that returns a component during render.
 */
export const zodiacIconFor: Record<Zodiac, SvgComponent> = {
  aries: zodiacIcons.Aries,
  taurus: zodiacIcons.Taurus,
  gemini: zodiacIcons.Gemini,
  cancer: zodiacIcons.Cancer,
  leo: zodiacIcons.Leo,
  virgo: zodiacIcons.Virgo,
  libra: zodiacIcons.Libra,
  scorpio: zodiacIcons.Scorpio,
  sagittarius: zodiacIcons.Sagittarius,
  capricorn: zodiacIcons.Capricorn,
  aquarius: zodiacIcons.Aquarius,
  pisces: zodiacIcons.Pisces,
}

export const planetIconFor: Record<Planet, SvgComponent> = PLANET_ICON

/** Title-case a lowercase enum value for display ("leo" → "Leo"). */
export function titleCase(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1)
}
